import { getVideoMetadata } from "@/app/actions";
import { CustomCategory } from "@/components/category";
import Duration from "@/components/duration";
import TeaserHeading from "@/components/teaser-heading";
import TeaserLinkedContent from "@/components/teaser-linked-content";
import VideoThumbnail from "@/components/video-thumbnail";
import { Content } from "@/services/content/types";
import classNames from "classnames";
import Link from "next/link";
import { use } from "react";

type LargeProps = {
  play: Content.Play;
  showLinkedContent?: boolean;
  largeHeader?: boolean;
  imagePriority?: boolean;
};

const Large = ({
  play,
  showLinkedContent = true,
  largeHeader = false,
  imagePriority = false,
}: LargeProps) => {
  const videoId = play.fields.quickchannelIds?.[0] || play.fields.videos?.[0];

  const videoMetadata = videoId
    ? use(
        getVideoMetadata({
          qbrick: play.fields.videos?.[0],
          quickchannel: play.fields.quickchannelIds?.[0],
        }),
      )
    : null;

  const title = play.fields.teaserTitle || play.fields.title;
  const image = play.fields.teaserImage || play.fields.image;
  const playShow = play.fields["play-show"];

  const hasLinkedContent = Boolean(play.fields.linkedContent?.length);

  return (
    <div className="bg-static-black-400">
      <Link
        href={`/play/${play.fields.slug}`}
        className={classNames("group block relative  overflow-hidden", {})}
      >
        <div className="relative">
          <VideoThumbnail
            fallbackUrl={videoMetadata?.thumbnail}
            thumbnailImage={image}
            imagePriority={imagePriority}
          />
          <Duration duration={videoMetadata?.duration} />
        </div>
        <div
          className={classNames("p-4", {
            "pb-0": hasLinkedContent,
          })}
        >
          {playShow && (
            <CustomCategory
              inverted
              color="Play"
              name={playShow.fields.title}
            />
          )}

          {title && (
            <TeaserHeading
              text={title}
              className={classNames(
                "font-semibold",
                "text-static-white",
                largeHeader ? "text-3xl md:text-5xl" : "text-3xl",
              )}
            />
          )}
        </div>
      </Link>
      {hasLinkedContent && showLinkedContent && (
        <div className="" data-mode="dark">
          <TeaserLinkedContent
            linkedContent={play.fields.linkedContent}
            showLinkedContent={showLinkedContent}
            compactMode={false}
            darkMode={true}
          />
        </div>
      )}
    </div>
  );
};

export default Large;
